import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SignupService} from "../../../services/signup.service";
import {Router} from "@angular/router";
import {validatePassword} from "../../../../common/utilities/CustomValidator";

@Component({
  selector: 'app-merchant-login',
  templateUrl: './merchant-login.component.html',
  styleUrls: ['./merchant-login.component.css']
})
export class MerchantLoginComponent implements OnInit {
  public showPasswordFieldText = false;
  public loginForm: FormGroup;

  // showNameError: boolean = false;
  // showBusinessNameError: boolean = false;
  // showEmailError: boolean = false;
  // showPasswordError: boolean = false;

  serverError: string | null = null


  constructor(private formBuilder: FormBuilder, public signupService: SignupService, private router: Router) {
  }

  ngOnInit() {
    this.signupService.currentStepBs.next(this.signupService.Step.MERCHANT_LOGIN);
    this.signupService.disableBackButton = true
    this.signupService.disableNextButton = false

    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, Validators.maxLength(320)]],
      password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(64)]]
    });
    this.signupService.loginForm = this.loginForm
  }

  get email() {
    return this.loginForm.get('email');
  }

  get password() {
    return this.loginForm.get('password');
  }

  togglePasswordShowButtonClicked() {
    console.log("togglePasswordShowButton");
    this.showPasswordFieldText = !this.showPasswordFieldText;
  }
}
